import React from 'react';

function Heading(){
    return <h1>
             <span>emojipedia</span>
           </h1> 
};

export default Heading;